var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visitaSinPedido || _vm.visitaComentarios)?_c('cardTodoNoOrder'):_c('cardCreateTodo')
}
var staticRenderFns = []

export { render, staticRenderFns }